import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import apiService from "../apiService"; // Importing the API service
import "../styles/_login.scss";

const Login = () => {
      const [email, setEmail] = useState("");
      const [password, setPassword] = useState("");
      const [error, setError] = useState("");
      const navigate = useNavigate();

      const handleSubmit = async (e) => {
            e.preventDefault();
            setError("");

            apiService.getAccessToken(email, password, (success, response) => {
                  if (success) {
                        const { access_token, refresh_token } = response;
                        localStorage.setItem("access_token", access_token);
                        localStorage.setItem("refresh_token", refresh_token);
                        navigate("/dashboard");
                  } else {
                        setError("Invalid credentials. Please try again.");
                  }
            });
      };

      return (
            <div className="login-container">
                  <img src="/images/logo-white.png" alt="Logo" className="logo" />
                  <div className="login-box">
                        <form onSubmit={handleSubmit}>
                              <div className="form-group">
                                    <input
                                          type="email"
                                          value={email}
                                          placeholder="Email"
                                          onChange={(e) => setEmail(e.target.value)}
                                          required
                                    />
                              </div>
                              <div className="form-group">
                                    <input
                                          type="password"
                                          value={password}
                                          placeholder="Password"
                                          onChange={(e) => setPassword(e.target.value)}
                                          required
                                    />
                              </div>
                              {error && (
                                    <p className="error-message" style={{ color: "black" }}>
                                          {error}
                                    </p>
                              )}
                              <div className="login-row">
                                    <span>
                                          Don’t have an account?{" "}
                                          <Link to="/signup" className="signup-link">
                                                Signup
                                          </Link>
                                    </span>
                                    <button type="submit" className="login-button">
                                          Login
                                    </button>
                              </div>
                        </form>
                  </div>
                  <div className="footer">
                        <div className="footer-links">
                              <a
                                    href="https://spraynozzle.com.au/contact/"
                                    className="footer-link"
                                    target="_blank"
                                    rel="noopener noreferrer"
                              >
                              Contact Us
                              </a>
                              <span className="vertical-bar">|</span>
                              <Link to="/privacy-policy" className="footer-link">
                                    Privacy Policy
                              </Link>
                              <span className="vertical-bar">|</span>
                              <Link to="/terms-conditions" className="footer-link">
                                    Terms & Conditions
                              </Link>
                        </div>
                        <div className="copyright">
                              ©2025 Spray Nozzle Engineering | All Rights Reserved
                        </div>
                  </div>
            </div>
      );
};

export default Login;
